// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  caseId: __t.u64().primaryKey().name("case_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  kind: __t.string(),
  accusedId: __t.u64().name("accused_id"),
  victimId: __t.u64().name("victim_id"),
  witnesses: __t.u32(),
  confidence: __t.u32(),
  status: __t.string(),
  detail: __t.string(),
  openedAt: __t.timestamp().name("opened_at"),
  resolvedAt: __t.timestamp().name("resolved_at"),
});
